import React from 'react';

function NotFound() {
    return (
        <div className="container">
            <h1>PATH NOT FOUND</h1>
        </div>
    );
}

export default NotFound;

